import { render, staticRenderFns } from "./ModalDocument.vue?vue&type=template&id=6526418f&"
import script from "./ModalDocument.vue?vue&type=script&lang=ts&"
export * from "./ModalDocument.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports